import { useOptimisticUpdateMutation } from "../../../hooks/useOptimisticUpdateMutation";
import { TUTORIAL_JOURNEYS_QUERY_KEY } from "../journey/TutorialJourneysList";
import TutorialJourneysService from "../../../services/TutorialJourneysService";
import { ITutorialJourneyDto } from "@growth-machine-llc/stridist-api-client";

export function useDeleteTutorialJourney() {
  return useOptimisticUpdateMutation({
    queryKey: [TUTORIAL_JOURNEYS_QUERY_KEY],
    mutationFn: TutorialJourneysService.deleteTutorialJourney,
    optimisticUpdater: {
      updateFn: (oldData: ITutorialJourneyDto[], id: number) =>
        oldData.filter((journey) => journey.id !== id),
    },
    invalidateQueryOptions: {
      enabled: true,
      refetchType: "none",
    },
  });
}
